import { useGetStationDisplayName } from "@/entities/station";

type EvacuatieBusOpstelLocatieProps = {
    opstelLocatie: string;
    afzetStation: string;
};

export const OpstelLocatieEnAfzetStation = ({ opstelLocatie, afzetStation }: EvacuatieBusOpstelLocatieProps) => {
    const stationDisplayName = useGetStationDisplayName("withoutStationCode");
    return (
        <div className="grid grid-cols-1 items-start justify-start gap-y-2">
            <div>
                <label className="leading-l text-s text-content-emphasis font-bold">Opstellocatie</label>
                <p className="whitespace-pre-line">{opstelLocatie}</p>
            </div>
            <div>
                <label className="leading-l text-s text-content-emphasis font-bold">Afzetstation</label>
                <p className="whitespace-pre-line">{stationDisplayName(afzetStation)}</p>
            </div>
        </div>
    );
};
